import React, { useState } from "react";
import { notify } from "../../../generic";
import { Modal } from "react-responsive-modal";
import { Col, Row } from "react-bootstrap";
import CtaButton from "../../Interface/CtaButton";

function NewCategorieModal({
  open,
  setOpen,
  categorieId,
  onSubmitAction,
  loading
}) {
  const [categorieName, setCategorieName] = useState("");
  const [nameError, setNameError] = useState(false);

  const handleModalClosure = () => {
    setCategorieName("");
    setNameError(false);
    setOpen(false);
  };

  const handleModalSubmission = async () => {
    const { type, message, details } = await onSubmitAction({
      categorieName,
      categorieId
    });

    if (type === "success") {
      notify("success", message);
      handleModalClosure();
    } else {
      notify("error", message);
    }
  };

  const handleCategorieSubmit = ({ key }) => {
    if (key === "Enter") {
      if (categorieName.length > 0) handleModalSubmission();
      else setNameError(true);
    }
  };

  return (
    <Modal closeIcon={<></>} open={open} onClose={handleModalClosure}>
      <Row>
        <Col xs={12}>
          <p>Ajouter une catégorie</p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <label>Nom de la catégorie</label>
          <input
            name="categorie"
            type="text"
            className={`form-control ${nameError ? "has-error" : ""}`}
            onChange={({ target }) => setCategorieName(target.value)}
            onKeyUp={handleCategorieSubmit}
            value={categorieName}
          />
          <span className={`invalid-feedback ${nameError ? "show" : ""}`}>
            La catégorie doit avoir un nom valide
          </span>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <CtaButton
            action={() => handleCategorieSubmit({ key: "Enter" })}
            text="Ajouter"
            busy={loading}
          />
          <a
            className="btn btn-default  float-end"
            onClick={handleModalClosure}
          >
            Annuler
          </a>
        </Col>
      </Row>
    </Modal>
  );
}

export default NewCategorieModal;
